import { render, staticRenderFns } from "./ClientPaymentSetting.vue?vue&type=template&id=d37992e6&scoped=true&"
import script from "./ClientPaymentSetting.vue?vue&type=script&lang=js&"
export * from "./ClientPaymentSetting.vue?vue&type=script&lang=js&"
import style0 from "./ClientPaymentSetting.vue?vue&type=style&index=0&id=d37992e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37992e6",
  null
  
)

export default component.exports